import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GuestFeedbackAnalysisRunListItemFragment = { __typename?: 'GuestFeedbackAnalysisRun', id: string, startedAt: string, completedAt?: string | null, error?: string | null, recommendationCount: number, locationGroup?: { __typename?: 'LocationGroup', id: string, name: string, type: Types.LocationGroupType } | null };

export type GuestFeedbackAnalysesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GuestFeedbackAnalysesQuery = { __typename?: 'Query', GuestFeedbackAnalysisRuns: Array<{ __typename?: 'GuestFeedbackAnalysisRun', id: string, startedAt: string, completedAt?: string | null, error?: string | null, recommendationCount: number, locationGroup?: { __typename?: 'LocationGroup', id: string, name: string, type: Types.LocationGroupType } | null }> };

export const GuestFeedbackAnalysisRunListItemFragmentDoc = gql`
    fragment GuestFeedbackAnalysisRunListItem on GuestFeedbackAnalysisRun {
  id
  startedAt
  completedAt
  error
  recommendationCount
  locationGroup {
    id
    name
    type
  }
}
    `;
export const GuestFeedbackAnalysesDocument = gql`
    query GuestFeedbackAnalyses {
  GuestFeedbackAnalysisRuns {
    ...GuestFeedbackAnalysisRunListItem
  }
}
    ${GuestFeedbackAnalysisRunListItemFragmentDoc}`;

/**
 * __useGuestFeedbackAnalysesQuery__
 *
 * To run a query within a React component, call `useGuestFeedbackAnalysesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestFeedbackAnalysesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestFeedbackAnalysesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuestFeedbackAnalysesQuery(baseOptions?: Apollo.QueryHookOptions<GuestFeedbackAnalysesQuery, GuestFeedbackAnalysesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestFeedbackAnalysesQuery, GuestFeedbackAnalysesQueryVariables>(GuestFeedbackAnalysesDocument, options);
      }
export function useGuestFeedbackAnalysesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestFeedbackAnalysesQuery, GuestFeedbackAnalysesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestFeedbackAnalysesQuery, GuestFeedbackAnalysesQueryVariables>(GuestFeedbackAnalysesDocument, options);
        }
export type GuestFeedbackAnalysesQueryHookResult = ReturnType<typeof useGuestFeedbackAnalysesQuery>;
export type GuestFeedbackAnalysesLazyQueryHookResult = ReturnType<typeof useGuestFeedbackAnalysesLazyQuery>;
export type GuestFeedbackAnalysesQueryResult = Apollo.QueryResult<GuestFeedbackAnalysesQuery, GuestFeedbackAnalysesQueryVariables>;